
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-label":"Records without Locations","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 13a9 9 0 00-1.39-4.78l-1.46 1.45A7 7 0 0113 20a7 7 0 01-3.33-.84l-1.43 1.45A8.86 8.86 0 0013.02 22 9 9 0 0022 13zM6.84 16.33A7 7 0 0113 6a7.06 7.06 0 013.33.84l1.45-1.45A8.89 8.89 0 0013 4a9 9 0 00-9 9 8.89 8.89 0 001.39 4.78z"}}),_c('path',{attrs:{"d":"M14.83 14H26v-2h-9.17l-2 2zM14 9.17V0h-2v11.17l2-2zM12 16.83V26h2V14.83l-2 2zM11.17 12H0v2h9.17l2-2zM1.692 22.9L22.905 1.689l1.414 1.414L3.106 24.315z"}})])
          )
        }
      }
    